<template>
  <div class="page">
    <a-table
      :columns="columns"
      :row-key="(record) => record.id"
      :data-source="dataSource"
      :loading="loading"
      size="small"
    >
      <template #bodyCell="{ column, record }">
        <template v-if="column.dataIndex === 'stopWS'">
          <WarningFilled
            v-if="record.stopWS"
            style="
               {
                font-size: 22px;
                color: red;
              }
            "
          />
          <span v-else>-</span>
        </template>
      </template>
    </a-table>
  </div>
</template>

<script>
  import { parseTime } from '@/utils'
  import { WarningFilled } from '@ant-design/icons-vue'
  import { getCloList } from '@/api/andon-overview'
  export default {
    components: { WarningFilled },
    props: {
      currentParams: {
        type: Object,
        default() {
          return {}
        },
      },
      isOpen: {
        type: Boolean,
        default: false,
      },
    },
    watch: {
      isOpen: {
        handler(v) {
          if (v) {
            this.getData()
          }
        },
        immediate: true,
      },
    },
    data() {
      return {
        loading: false,
        columns: [
          {
            title: 'No',
            dataIndex: 'no',
            key: 'no',
            customRender({ index }) {
              return index + 1
            },
            width: 60,
          },
          {
            title: 'Description',
            dataIndex: 'andonDesc',
            minWidth: 100,
          },
          {
            title: 'Job ID',
            dataIndex: 'job_id',
            minWidth: 100,
          },
          {
            title: 'Region Code',
            dataIndex: 'region_code',
            minWidth: 100,
            sorter: (a, b) =>
              a.region_code.charCodeAt() - b.region_code.charCodeAt(),
          },
          {
            title: 'Create Time',
            dataIndex: 'create_on',
            minWidth: 100,
            defaultSortOrder: 'descend',
            customRender({ text }) {
              return parseTime(text, '{m}/{d} {h}:{i}')
            },
            sorter: (a, b) =>
              a.create_on.charCodeAt() - b.create_on.charCodeAt(),
          },
          {
            title: 'Resp.By',
            dataIndex: 'resp_by',
            minWidth: 100,
          },
          {
            title: 'Stop WS',
            dataIndex: 'stop_WS',
            minWidth: 100,
          },
          {
            title: 'Lost Hr',
            dataIndex: 'lostHr',
            minWidth: 100,
            sorter: (a, b) => a.lostHr - b.lostHr,
          },
          {
            title: 'Resp(Min)',
            dataIndex: 'resp',
            minWidth: 100,
            sorter: (a, b) => a.resp - b.resp,
          },
          {
            title: 'Close(Hr)',
            dataIndex: 'closeHr',
            minWidth: 100,
            sorter: (a, b) => a.closeHr - b.closeHr,
          },
          {
            title: 'Status',
            dataIndex: 'status',
            minWidth: 100,
            sorter: (a, b) => a.status.charCodeAt() - b.status.charCodeAt(),
          },
        ],
      }
    },
    methods: {
      async refresh() {
        await this.getData()
        return Promise.resolve()
      },
      async getData() {
        this.loading = true
        try {
          const { body } = await getCloList(this.currentParams)
          this.dataSource = body || []
          this.loading = false
        } catch (e) {
          this.loading = false
        }
        return Promise.resolve()
      },
    },
  }
</script>

<style lang="less" scoped></style>
